import styled from 'styled-components'

export const Card = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.ds.colors.neutral200};

  @media (max-width: 959px) {
    gap: 8px;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 959px) {
    gap: 0;
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const BadgeRN = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37px;
  height: 52px;
  background-color: ${({ theme }) => theme.ds.colors.primary300};
  border-radius: 4px;

  &::after {
    content: 'RN';
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    font-weight: 500;
    font-family: ${({ theme }) => theme.ds.typography.fontFamily};
    color: ${({ theme }) => theme.ds.colors.white};
  }
`
